// extracted by mini-css-extract-plugin
module.exports = {"article-details":"styles__article-details__c5Zul","articleDetails":"styles__article-details__c5Zul","author":"styles__author__294Ad"};